import { deviceConstants } from "../actions/constants/deviceContstants";
import { put, call } from "redux-saga/effects";
import { deviceService } from "../Service/deviceService";

function* deviceList() {
    try {
        const response = yield call(deviceService.deviceList); 

        if(response.statusCode === 200){
            yield put({
                type : deviceConstants.GetAllDevicesSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:deviceConstants.GetAllDevicesFailure,
                payload: response.status
            });
        }      
      } catch (error) {

        yield put({
            type:deviceConstants.GetAllDevicesFailure,
            payload: error
        });
    }
}

function* assignDevice(action) {
  try {
    const response = yield call(deviceService.AssignDevice, action.payload);
    if (response.statusCode === 200) {
      yield put({ type: deviceConstants.AssignDeviceToFieldSuccess, payload: response.resultObject });

    } else {
      yield put({ type: deviceConstants.AssignDeviceToFieldFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: deviceConstants.AssignDeviceToFieldFailure, payload: error });
  }
}


function* updateCredentials(request) {
    try {
        const response = yield call(deviceService.UpdateCredentials,request.payload);
        
        if(response.statusCode === 200){
            yield put({
                type : deviceConstants.UpdateCredentialsSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:deviceConstants.UpdateCredentialsFailure,
                payload: response.errorMessage
            });
        }      
      } catch (error) {

        yield put({
            type:deviceConstants.UpdateCredentialsFailure,
            payload: error
        });
    }
}

export const deviceSaga = {
    deviceList,
    assignDevice,
    updateCredentials
}
